import { connect } from 'react-redux';
import { change as changeFormValue } from 'redux-form';
import CabinUpgrade from '../components/CabinUpgrade';
import { CABIN_UPGRADE } from '../../products';
import { getSelectedUpgrades, getUnselectedUpgrades, isProductSelected, isUpgradeSaved } from '../utils/utils';
const {
  name
} = CABIN_UPGRADE;
export const mapStateToProps = (state, _ref) => {
  let {
    form
  } = _ref;
  return {
    selectedUpgrades: getSelectedUpgrades(form, name, state),
    unselectedUpgrades: getUnselectedUpgrades(form, name, state),
    isUpgradeSaved: isUpgradeSaved(form, name, state),
    isProductSelected: isProductSelected(form, name, state)
  };
};
export const mapDispatchToProps = (dispatch, _ref2) => {
  let {
    form
  } = _ref2;
  return {
    updateSelectedCabinUpgrades: _ref3 => {
      let {
        priceRaw,
        selectedUpgrades,
        unselectedUpgrades,
        value
      } = _ref3;
      return dispatch(changeFormValue(form, `${CABIN_UPGRADE.name}.value`, {
        value,
        selectedUpgrades,
        unselectedUpgrades,
        priceRaw
      }));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CabinUpgrade);
//# sourceMappingURL=CabinUpgradeContainer.js.map